import { requestJson, tabPath, type TabUpdateSettings } from './custom-dashboard';

/**
 * タブの定期更新の設定を保存する（後勝ち。T-0059）。曜日が空なら設定を消し（定期更新しない）、`updateSettings` は
 * null で返る。タブが削除されていれば 404。
 */
export const saveCustomDashboardTabUpdateSettings = (
  accountId: string,
  tabId: string,
  body: TabUpdateSettings,
  authHeaders: Record<string, string>,
  signal?: AbortSignal,
): Promise<{ updateSettings: TabUpdateSettings | null }> =>
  requestJson(
    tabPath(accountId, tabId, '/update-settings'),
    { method: 'PUT', body: JSON.stringify(body), signal },
    authHeaders,
  );
